import React, {Component} from 'react'
import server from '../server';

class Employee extends Component{
    state = {
      modal:false
    }

    render(){
        return(
            <div style={{display:"inline-block"}} class="bdrs-2 bd m-20 card  cur-p open-details">
                <div class="client-image">
                    <img class="bdrsT-2  w-100p" src={server.imagePath + "/profile/" + this.props.data.profilePicture} alt=""/>
                </div>
                <div class="client-info p-10">
                    <h5 class="c-client-default">
                        <b>{this.props.data.name}</b>
                    </h5>
                    <hr class="small m-0"/>
                    <p>{this.props.data.rank == "doctor" ? "Médico" : "Secretária"}</p>
                </div>
            </div>
        )
    }
}

export default Employee



// WEBPACK FOOTER //
// ./src/panels/Employee.js